var React = require('react');

function IconHelpInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.55493","cy":"11.1211","r":"8.5","stroke":"#212121","key":0}),React.createElement("path",{"d":"M9.02 9.36H10.16V15H9.02V9.36ZM8.84 7.356C8.84 7.148 8.912 6.972 9.056 6.828C9.2 6.676 9.376 6.6 9.584 6.6C9.792 6.6 9.968 6.676 10.112 6.828C10.264 6.972 10.34 7.148 10.34 7.356C10.34 7.564 10.264 7.74 10.112 7.884C9.968 8.028 9.792 8.1 9.584 8.1C9.376 8.1 9.2 8.028 9.056 7.884C8.912 7.74 8.84 7.564 8.84 7.356Z","fill":"black","key":1})]);
}

IconHelpInline.defaultProps = {"width":"19","height":"21","viewBox":"0 0 19 21","fill":"none"};

module.exports = IconHelpInline;

IconHelpInline.default = IconHelpInline;
